import { motion } from "framer-motion";
import { Zap, Building2, Cog, Cable } from "lucide-react";

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden">
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

const STRIP = [
  { icon: Zap, label: "Electrical Installations" },
  { icon: Building2, label: "Commercial Solutions" },
  { icon: Cog, label: "Industrial Systems" },
  { icon: Cable, label: "Fiber Optic Installations" },
];

export const Hero = () => (
  <section className="relative overflow-hidden bg-[#0B0F19]" data-testid="hero-section">
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-10 py-14 lg:grid-cols-2 lg:gap-6 lg:py-20">
        <div className="relative z-10">
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#F8FAFC]"
            data-testid="hero-kicker"
          >
            Powering Today
            <br />
            Connecting Tomorrow
          </motion.p>

          <h1 className="mt-7 font-display text-5xl font-bold uppercase leading-[1.0] tracking-tight sm:text-6xl lg:text-7xl" data-testid="hero-headline">
            <Line delay={0.25}>Expert Solutions</Line>
            <Line delay={0.4}>
              <span className="text-[#FF5B00]">For a Stronger</span>
            </Line>
            <Line delay={0.5}>
              <span className="text-[#FF5B00]">Tomorrow</span>
            </Line>
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.75 }}
            className="mt-6 text-base leading-relaxed text-[#F8FAFC] sm:text-lg"
            data-testid="hero-subcopy"
          >
            Residential. Commercial. Industrial.
            <br />
            Fiber Optic Installers.
          </motion.p>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.9 }}
            className="mt-8 h-1 w-16 bg-[#FF5B00]"
          />
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <img
            src="/assets/hero-electrician.jpg"
            alt="SMS Electrical professional in hard hat at an electrical installation"
            className="w-full object-cover [mask-image:linear-gradient(to_right,transparent,black_18%)] lg:[mask-image:linear-gradient(to_right,transparent,black_22%)]"
            data-testid="hero-image"
          />
        </motion.div>
      </div>
    </div>

    <div className="relative border-t border-[#1E293B]">
      <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
        {STRIP.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 + i * 0.12 }}
            className="flex flex-col items-center gap-3 border-[#1E293B] px-4 py-7 text-center odd:border-r sm:flex-row sm:text-left lg:justify-center lg:border-r lg:last:border-r-0"
            data-testid={`hero-strip-${i}`}
          >
            <s.icon className="h-7 w-7 shrink-0 text-[#FF5B00]" strokeWidth={1.8} />
            <span className="font-mono-tech text-[10px] font-semibold uppercase leading-snug tracking-[0.18em] text-[#F8FAFC]">
              {s.label}
            </span>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
